module.exports = __webpack_public_path__ + "static/media/bike1-.6ab6969d.jpg";